<script setup lang="ts">
import { pascalCase } from "scule";
import { resolveComponent } from "vue";
import type { Ref } from "vue";
import { useNavigationContext } from "#imports";
import type { Schemas } from "#shopware";

defineOptions({
  name: "PageResolverContent",
});

const props = defineProps<{
  seoResult: Schemas["SeoUrl"];
}>();

const seoResultRef = toRef(props, "seoResult");

const { routeName, foreignKey } = useNavigationContext(
  seoResultRef as Ref<Schemas["SeoUrl"]>,
);

const NOT_FOUND_COMPONENT = "errors/RoutingNotFound";

const notFoundComponent = resolveComponent(pascalCase(NOT_FOUND_COMPONENT));

const resolvedComponent = computed(() => {
  const name = routeName.value;
  if (!name) return null;
  const pascal = pascalCase(name as string);
  const comp = resolveComponent(pascal);
  return comp !== pascal ? comp : null;
});

// Cache issue change 03
const isSeoNotFound = !props.seoResult?.foreignKey;

if (import.meta.server && !isSeoNotFound) {
  const event = useRequestEvent();
  if (event) {
    const entityId = props.seoResult?.foreignKey;
    const rName = props.seoResult?.routeName;
    const tags: string[] = [];

    if (rName === "frontend.navigation.page") {
      tags.push("all-pages", "catalog", "category");
      if (entityId) tags.push(`category-${entityId}`);
    } else if (rName === "frontend.detail.page") {
      tags.push("all-pages", "catalog", "product");
      if (entityId) tags.push(`product-${entityId}`);
    }

    if (tags.length) {
      const cacheTagString = tags.join(",");
      const responseHeader = useResponseHeader("Vercel-Cache-Tag");
      responseHeader.value = cacheTagString;
    }
  }
}
</script>

<template>
  <div>
    <component
      v-if="resolvedComponent"
      :is="resolvedComponent"
      :navigationId="foreignKey"
      class="main-inner"
    />
    <component
      v-else
      :is="notFoundComponent"
    />
  </div>
</template>
